import { FormControl, FormLabel, Input, Text } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
interface InputProps {
  name: string;
  control: any;
  errors?: any;
   label: string | React.ReactNode;
  type?: string;
  placeholder?: string;
  isRequired?: boolean;
  min?: string;
  max?: string;
  maxLength?: number;
  disable?: boolean
  readOnly?: boolean
    bgColor?: string;
}

 const FormInput = ({
  name,
  control,
  errors,
  label,
  type = "text",
  placeholder,
  isRequired = false,
  min,
  max,
  maxLength,
  disable,
  readOnly,
    bgColor = "white"
}: InputProps) => {

  const error = get(errors, name);


  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl isRequired={isRequired} isInvalid={!!errors?.[name]} mt={2}>
          <FormLabel className='font-poppins text_medium text_md '>
            {label}
          </FormLabel>
          <Input {...field} type={type} placeholder={placeholder} min={min} max={max} maxLength={maxLength} disabled={disable} readOnly={readOnly} bg={bgColor}/>
            {/* {errors?.[name] && (
              <Text color="red.500" textAlign="left">{errors[name].message}</Text>
            )} */}

           {error?.message && (
            <Text color="red.500" textAlign="left">
              {error.message}
            </Text>
          )}

        </FormControl>
      )}
    />
  );
};

export default FormInput;